// extracted by mini-css-extract-plugin
module.exports = {"universalQuery":"UniversalQuery_universalQuery__3B_j4","report":"UniversalQuery_report__IZF8h"};